import React, {useCallback, useMemo, useState} from 'react';
import {
    MaterialReactTable,
    MRT_GlobalFilterTextField,
    MRT_ToggleFiltersButton,
    MRT_ToolbarAlertBanner
} from 'material-react-table';
import {MRT_Localization_RU} from "material-react-table/locales/ru";
import Box from "@mui/material/Box";
import {Link} from "react-router-dom";
import ModalConfirm from "../../../modal/ModalConfirm";
import ModalOpenSetValues from "../material/arrival/ModalOpenSetValues";
import MaterialPriceUnitService from "../../../../../API/orders/warehouse/MaterialPriceUnitService";
import ButtonCreate from "../../../button/ButtonCreate";
import {materialEstimateUnitStates} from "../../../../../data/MaterialEstimateUnitState";
import selectionTableUtil, {normalizeSelection} from "../../../../../utils/common/SelectionTableUtil";
import {handlerExport} from "../../../../../pages/common/settings/handlerExport";
import MaterialEstimateUnitService from "../../../../../API/orders/estimate/organization/MaterialEstimateUnitService";
import {Button, Checkbox} from "@mui/material";
import FilterUtil from "../../../../../utils/common/FilterUtil";
import {HeaderOPTAdditionally} from "../../orders/organization/production/HeaderOPT";
import CellOPTm from "../../orders/organization/production/CellOPTm";
import ModalWidthCheckbox from "../../../modal/ModalWidthCheckbox";

const RequestsPurchaseTableItem = ({
                                       orderId,
                                       orderNumber,
                                       status,
                                       estimateId,
                                       data,
                                       setData,
                                       rowSelection,
                                       setRowSelection,
                                       tableOptions,
                                       tableOptionsHandle,
                                       handleSubmitSetPurchase,
                                       handleModalAlert,
                                       errorIds,
                                       unitMap,
                                       statusList,
                                       globalFilter,
                                       handleSearchQuery,
                                       filteredData,
                                       columnsFilter,
                                       loading
                                   }) => {

        const [modalCurrencyOpen, setModalCurrencyOpen] = useState(false);
        const [currentCurrencyBM, setCurrentCurrencyBM] = useState([]);

        const [updateModalOpen, setUpdateModalOpen] = useState(false);

        const [currentEditRowData, setCurrentEditRowData] = useState(null);
        const [currentEditRowId, setCurrentEditRowId] = useState(null);

        const [titleModalOpenSetValues, setTitleModalOpenSetValues] = useState(null);
        const [labelModalOpenSetValues, setLabelModalOpenSetValues] = useState(null);
        const [materialPriceUnits, setMaterialPriceUnits] = useState(new Map());

        const [setPurchaseModalOpen, setSetPurchaseModalOpen] = useState(false);
        const [createReservesModalOpen, setCreateReservesModalOpen] = useState(false)
        const [showColumnFilters, setShowColumnFilters] = useState(false)

        const handleShowColumnFilters = () => {
            setShowColumnFilters(!showColumnFilters)
            if (showColumnFilters) {
                handleSearchQuery([], data, null, true)
            }
        }

        const {onRowSelectionChange} = selectionTableUtil(data, setRowSelection)
        const currentSelection = normalizeSelection(rowSelection)

        const handleUpdateModel = useCallback(
            (row) => {
                setCurrentEditRowData(row.original);
                setCurrentEditRowId(row.index);
                setUpdateModalOpen(true);
            },
            [data, currentEditRowData, setCurrentEditRowData],
        );

        const updateCurrencyByIds = async () => {
        }

        const handleCloseModalCurrency = () => {
            setModalCurrencyOpen(false);
        };

        const columns = useMemo(
            () => [
                {
                    id: 'articleNumber',
                    header: 'Артикул',
                    accessorKey: 'articleNumber',
                    size: 160,
                },
                {
                    id: 'name',
                    header: 'Наименование',
                    accessorKey: 'name',
                    minSize: 550,
                    Cell: ({cell, row}) => {
                        return (
                            <Link
                                to={'/organization/materials/' + row.original.materialOId + '/' + unitMap[row.original.unitId] + '/' + row.original.typeMaterial + '/' + row.original.materialId}>{cell.getValue()}</Link>
                        )
                    }
                },
                {
                    id: 'unitId',
                    header: 'Ед. изм.',
                    accessorKey: 'unitId',
                    minSize: 5,
                    maxSize: 5,
                    Cell: ({cell}) => unitMap[cell.getValue()],
                },
                {
                    id: 'materialEstimateUnitState',
                    header: 'Статус',
                    accessorKey: 'materialEstimateUnitState',
                    filterVariant: 'multi-select',
                    filterSelectOptions: statusList,
                    size: 140,
                    Cell: ({cell}) => materialEstimateUnitStates[cell.getValue()],
                    filterFn: (row, id, filterValue) => {
                        return materialEstimateUnitStates[row.original.materialEstimateUnitState].toLowerCase().includes(filterValue.toLowerCase())
                    },
                    muiFilterTextFieldProps: {
                        placeholder: 'Отфильтровать по статус',
                        sx: {
                            width: '140px',
                        },
                    }
                },
                {
                    id: 'note',
                    header: 'Заметки',
                    accessorKey: 'note',
                    maxSize: 50,
                },
                {
                    id: 'quantity',
                    header: 'Кол.',
                    accessorKey: 'quantity',
                    maxSize: 50,
                    Cell: ({cell, row, rowIndex}) => {
                        const temp = row.original.materialOrganizationOption === null;
                        const isSlab = temp ? null : row.original.typeMaterial === 'SLAB';
                        const link = temp ? null : <Link
                            to={'/organization/orders/' + orderId + '/' + encodeURIComponent(orderNumber) + '/estimates/' + estimateId + '/' + status + '/' + false + '/reservation/'
                                + row.original.id + '/' + isSlab + '/' + encodeURIComponent(row.original.name)
                                + '/' + (encodeURIComponent(row.original.articleNumber) || null) + '/' + 'plan/true/' + row.original.materialEstimateUnitState + "/" + unitMap[row.original.unitId]}>
                            {cell.getValue().toFixed(3)}
                        </Link>
                        return (
                            <span
                                style={{
                                    color: temp ? 'red' : 'black'
                                }}>
                               {link}
                            </span>
                        );
                    },
                },
                {
                    id: 'issue',
                    header: 'Выдано',
                    accessorKey: 'issue',
                    size: 8,
                    enableEditing: false,
                    filterVariant: 'multi-select',
                    filterSelectOptions: FilterUtil.statusList,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    filterFn: (row, id, filterValue) => {
                        return FilterUtil.checkStatus(row.getValue(id), filterValue)
                    },
                    Cell: ({cell, row}) => <Checkbox
                        cell={cell}
                        disabled={true}
                        checked={row.original.issue}
                        sx={{padding: "7px 12px", '& .MuiSvgIcon-root': {fontSize: 22}}}
                    >
                    </Checkbox>,
                },
                {
                    id: 'inStock',
                    header: 'На складе',
                    accessorKey: 'inStock',
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => {
                        const white = row.original.quantity !== row.original.inStock
                        return <CellOPTm
                            row={row}
                            cell2={cell}
                            green={!white}
                            white={white}
                            bigCell={true}
                            cellEstimate={cell.getValue()}
                        />
                    }
                },
                {
                    id: 'waitingForDelivery',
                    header: 'Ожидает поставки',
                    accessorKey: 'waitingForDelivery',
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => <CellOPTm
                        row={row}
                        cell2={cell}
                        white={true}
                        bigCell={true}
                        requestsPurchase={true}
                        cellEstimate={cell.getValue()}
                    />
                },
                {
                    id: 'executorForApplication',
                    header: 'Сформирована закупка',
                    accessorKey: 'executorForApplication',
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => <CellOPTm
                        row={row}
                        cell2={cell}
                        white={true}
                        bigCell={true}
                        requestsPurchase={true}
                        cellEstimate={cell.getValue()}
                    />
                },
                {
                    id: 'waitingForApplication',
                    header: 'Ожидает закупки',
                    accessorKey: 'waitingForApplication',
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => <CellOPTm
                        row={row}
                        cell2={cell}
                        white={true}
                        bigCell={true}
                        requestsPurchase={true}
                        cellEstimate={cell.getValue()}
                    />
                },
                {
                    id: 'wait',
                    header: 'Ожидает действий',
                    accessorKey: 'wait',
                    size: 34,
                    minSize: 1,
                    grow: false,
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableColumnFilter: false,
                    enableSorting: false,
                    Header: ({column}) => <HeaderOPTAdditionally
                        column={column} height={100}></HeaderOPTAdditionally>,
                    Cell: ({row, cell}) => <CellOPTm
                        row={row}
                        cell2={cell}
                        white={true}
                        bigCell={true}
                        requestsPurchase={true}
                        cellEstimate={cell.getValue()}
                    />
                },

                {
                    header: 'id',
                    accessorKey: 'id',
                    enableColumnActions: false,
                    enableGrouping: false,
                    enableEditing: false,
                    size: 2,
                },
            ],
            [data, setData, filteredData],
        );
        const handleSubmitExport = () => {
            handlerExport(() => MaterialEstimateUnitService.export(orderId, orderNumber), handleModalAlert)
        }
        return (
            <Box sx={{width: showColumnFilters ? "1650px" : '1600px',}}>
                <Box
                    sx={{display: 'flex', justifyContent: "flex-end", paddingBottom: "30px"}}
                >
                    <Box sx={{display: 'flex', justifyContent: "spase-between", gap: "20px"}}>
                        <ButtonCreate
                            tooltip={"Материалы в которых созданы резервы игнорируются"}
                            text={"Создать резервы"}
                            width={200}
                            onClick={() => setCreateReservesModalOpen(true)}
                            // disabled={status !== 'IN_WORK' || rowSelection.length > 0}
                        />
                        <ButtonCreate
                            tooltip={"Поданные на закупку материалы игнорируются"}
                            text={"Подать резервы на закупку"}
                            width={280}
                            onClick={() => setSetPurchaseModalOpen(true)}
                            // disabled={status !== 'IN_WORK' && status !== "CREATED_RESERVES"}
                        />
                        <ButtonCreate
                            text={"Экспорт"}
                            width={80}
                            icon={false}
                            onClick={handleSubmitExport}
                        />
                        {errorIds?.length > 0 && <Button
                            size="small"
                            color="secondary"
                            variant="contained"
                            sx={{
                                animation: 'blinking 1s infinite',
                                WebkitAnimation: 'blinking 1s infinite',
                                '@keyframes blinking': {
                                    '0%': {backgroundColor: '#fff'},
                                    '50%': {backgroundColor: '#f00'},
                                    '100%': {backgroundColor: '#fff'},
                                },
                            }}
                        >
                            Наименования одинаковые
                        </Button>}
                    </Box>
                </Box>
                <Box sx={{overflow: 'auto'}}>
                    <MaterialReactTable
                        muiTableContainerProps={{
                            sx: {
                                maxHeight: rowSelection?.length > 0 ? `calc(100vh - 600px)` : `calc(100vh - 500px)`,
                                width: showColumnFilters ? "1650px" : "1600px"
                            }
                        }}
                        renderTopToolbar={({table}) => {
                            return <Box sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                padding: "7px",
                                backgroundColor: (theme) => table.getSelectedRowModel().rows.length > 0 ? theme.palette.primary.light : "transparent",
                            }}>
                                <MRT_ToolbarAlertBanner table={table}/>
                                <Box sx={{display: "flex"}}>
                                    <MRT_ToggleFiltersButton table={table}/>
                                    <MRT_GlobalFilterTextField table={table}/>
                                </Box>
                            </Box>
                        }}
                        selectAllMode={"all"}
                        muiTableBodyCellProps={({cell, table}) => {
                            const errorRow = errorIds?.includes(cell.row.original.id)
                            return ({
                                sx: {
                                    p: '0px 0px 0px 10px',
                                    m: '0px 0px 0px 0px',
                                    border: "none",
                                    backgroundColor: errorRow && "red",
                                    "&:after": {
                                        display: "none",
                                    },
                                    "& td:after": {
                                        "&:hover": {
                                            backgroundColor: "red"
                                        }
                                    },
                                    "&:not(:last-of-type)": {
                                        borderRight: '1px solid #EAEBEA',

                                    },
                                    "&:nth-of-type(n+8)": {
                                        padding: 0,
                                    },
                                    "&:first-of-type": {
                                        padding: 0,
                                        width: "50px",
                                        height: "36px",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                    },

                                    "& a": {
                                        color: errorRow ? "white" : "#006CCC",
                                        textDecoration: "none",
                                        "&:hover": {
                                            textDecoration: "underline"
                                        }

                                    }
                                },
                            })
                        }}
                        muiTableHeadCellProps={({table, column}) => {
                            return ({
                                sx: {
                                    border: '1px solid #EAEBEA',
                                    backgroundColor: "#F5F6FA",
                                    padding: ['mrt-row-select', "mrt-row-actions", "issue"].includes(column.id) ? "0 5px" : ["inStock", "waitingForDelivery", "executorForApplication", "waitingForApplication", "wait"].includes(column.id) ? 0 : '0px 0px 0px 10px',
                                    verticalAlign: "bottom",
                                    "& .Mui-TableHeadCell-Content": {
                                        alignItems: "end",
                                        "& .Mui-TableHeadCell-Content-Wrapper": {
                                            justifyContent: "center",
                                            display: "flex",
                                        },
                                        "& .Mui-TableHeadCell-Content-Labels": {
                                            alignItems: "end",


                                            "& span": {
                                                marginBottom: "3px"
                                            }
                                        }
                                    },
                                    "& .MuiCollapse-root .MuiSelect-select": {
                                        padding: "0 !important",
                                        "& .MuiChip-label": {
                                            paddingLeft: "5px",
                                            paddingRight: "5px",
                                        }
                                    }
                                },
                            })
                        }}
                        muiTableBodyRowProps={({row}) => {
                            return ({
                                sx: () => ({
                                    height: '36px',
                                    backgroundColor: "white",
                                    "&:hover& td:after": {
                                        display: "none",
                                    },
                                    "&.MuiTableRow-root.Mui-selected": {
                                        backgroundColor: (theme) => theme.palette.primary.light70,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.light50,
                                        },
                                    },
                                    "&:hover": {
                                        "& td:after": {
                                            display: "none",
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.stroke,
                                    },
                                    '&:nth-of-type(even)': {
                                        "&.MuiTableRow-root.Mui-selected": {
                                            backgroundColor: (theme) => theme.palette.primary.light,
                                            "&:hover": {
                                                backgroundColor: (theme) => theme.palette.primary.light50,
                                            },
                                        },
                                        backgroundColor: (theme) => theme.palette.primary.lightGrey,
                                        "&:hover": {
                                            backgroundColor: (theme) => theme.palette.primary.stroke,
                                        },
                                    },
                                })
                            })
                        }}

                        muiSearchTextFieldProps={{
                            placeholder: `Поиск`,
                            sx: {
                                paddingTop: "5px",
                                paddingBottom: "0px",
                                "& .MuiCollapse-root": {
                                    borderRadius: '12px',
                                    height: 40, width: 290,
                                    "& .MuiSvgIcon-root": {
                                        color: "#737478"
                                    },
                                    '& .MuiOutlinedInput-input': {
                                        padding: 0
                                    }
                                }
                            },
                            variant: 'outlined',
                        }}
                        displayColumnDefOptions={{
                            'mrt-row-select': {
                                size: "50px",
                                grow: false,
                            },
                        }}

                        columns={columns}
                        data={filteredData}
                        enableMultiRowSelection
                        enableRowSelection={(row) => row.original.materialEstimateUnitState === 'IN_WORK' || row.original.materialEstimateUnitState === 'CREATED_RESERVES'}
                        rowHeight={13}
                        columnSpacing={1}
                        initialState={{
                            columnVisibility: {
                                id: false,
                            },
                            sorting: [{id: 'unitId', desc: false}],
                            pagination: {pageIndex: 0, pageSize: 50},
                        }}

                        onRowSelectionChange={onRowSelectionChange}
                        onPaginationChange={(updater) => {
                            tableOptionsHandle(updater(tableOptions));
                        }}
                        onGlobalFilterChange={(value) => {
                            handleSearchQuery(value, data, null)
                        }}
                        onColumnFiltersChange={(updater) => {
                            handleSearchQuery(updater(columnsFilter), data, null, true)
                        }}
                        onShowColumnFiltersChange={handleShowColumnFilters}
                        state={{
                            showColumnFilters: showColumnFilters,
                            columnFilters: columnsFilter,
                            globalFilter: globalFilter,
                            rowSelection: currentSelection,
                            showGlobalFilter: true,
                            pagination: tableOptions
                        }}
                        manualFiltering={true}
                        getRowId={(originalRow) => originalRow.id}
                        rowCount={tableOptions.totalElements}
                        selectionPadding={1}
                        selectionCss={{
                            backgroundColor: 'lightblue',
                            borderWidth: '2px',
                            borderStyle: 'solid',
                            borderColor: 'blue',
                            borderRadius: '4px',
                        }}

                        muiToolbarAlertBannerProps={{
                            sx: {
                                backgroundColor: (theme) => theme.palette.primary.light,
                                "& .MuiStack-root": {
                                    padding: 0,
                                    "& .MuiBox-root": {
                                        padding: "5px"
                                    }
                                },

                            }
                        }}
                        enableStickyHeader={true}
                        enableStickyFooter={true}
                        enableToolbarInternalActions={false}
                        localization={MRT_Localization_RU}
                    />
                </Box>
                <ModalOpenSetValues
                    title={titleModalOpenSetValues}
                    label={labelModalOpenSetValues}
                    modalOpen={modalCurrencyOpen}
                    handleClose={handleCloseModalCurrency}
                    setValue={setCurrentCurrencyBM}
                    handleSubmit={updateCurrencyByIds}
                />
                <ModalWidthCheckbox
                    open={createReservesModalOpen}
                    onClose={() => setCreateReservesModalOpen(false)}
                    handleSubmit={(ignoreSlab, handleClose) => handleSubmitSetPurchase(true, true, handleClose, ignoreSlab)}
                    title={"Подтвердить создание резервов?"}
                    action={"Подтвердить"}
                    loading={loading}/>

                <ModalWidthCheckbox
                    open={setPurchaseModalOpen}
                    onClose={() => setSetPurchaseModalOpen(false)}
                    handleSubmit={(ignoreSlab, handleClose) => handleSubmitSetPurchase(true, false, handleClose, ignoreSlab)}
                    title={"Подать резервовы на закупку?"}
                    action={"Подтвердить"}
                    loading={loading}/>
            </Box>
        );
    }
;

export default RequestsPurchaseTableItem;

